// i18n.js
import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import fr from '../locales/fr.json'
import { getDefaultLocale } from '@/store/modules/locale';
import { watch } from 'vue';
import store from '../store'


// Watch for changes in the Vuex store and update the i18n locale
watch(
    () => store.state.locale.locale,
    (newLocale) => {
       i18n.global.locale.value = newLocale;
    }
 );

export const i18n = createI18n({
  legacy: false, // this line will prevent an error when accessing t in script tags
  locale: getDefaultLocale(), // Set the default locale
  fallbackLocale: 'en', // set fallback locale
  messages: {
    en, 
    fr,
  },
});


